import jsPDF from "jspdf";
import { formatAdmitCardDateTime, formatDate, formatDateDDMMYYYY, formatDateTime, getAdmitCardDate, parseBackendDate, parseBackendDateContest } from "./data&dateTime";
import directorSignImage from "../assets/Images/Dir_signatures.jpeg";
import image from "../assets/Images/college-logo.png";
import { formatCourseListWithRoman } from "./ConvertRoman";
import html2canvas from "html2canvas";
import QRCode from "qrcode";
import arctLogo from "../assets/Images/arct2.0.png";
import career from "../assets/Images/Career.png";
import ARCTBITE from "../assets/Images/ARCTBITE.png";
import ARCTStrip from "../assets/Images/ARCTStrip.png";





export const generateAdmitCardPdf = async (details) => {
    const { name, father_name, arct_roll_number, created_at, admit_card_issued_at } = details;
    // const dateObj = parseBackendDateContest(admit_card_issued_at);

    // Format date as "12 Dec 2024"
    // const formattedDate = dateObj.toLocaleDateString("en-GB", {
    //     day: "2-digit",
    //     month: "short",
    //     year: "numeric",
    // });
    //   const formattedDate = formatDateTime(parseBackendDateContest(admit_card_issued_at));

    // const dateObj = getAdmitCardDate(admit_card_issued_at);

    // const formattedDate = dateObj.toLocaleDateString("en-GB", {
    //     day: "2-digit",
    //     month: "short",
    //     year: "numeric",
    // });


    // const dateObj = getAdmitCardDate(admit_card_issued_at);
    // const dateObj = parseBackendDateContest(admit_card_issued_at);


    // const formattedDate = dateObj.toLocaleDateString("en-GB", {
    //     timeZone: "Asia/Kolkata",
    //     day: "2-digit",
    //     month: "short",
    //     year: "numeric",
    // });

    // const formattedDate = admit_card_issued_at
    const formattedDate = admit_card_issued_at
        ? new Date(admit_card_issued_at).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "long",
            year: "numeric",
            timeZone: "Asia/Kolkata"
        })
        : "";
    // console.log("admit_card_issued_at====>>",admit_card_issued_at);
    // console.log("formatted date is here -----",formattedDate);
    // Generate QR code
    const qrDataUrl = await QRCode.toDataURL(arct_roll_number, {
        width: 150,
        margin: 1,
        color: { dark: "#ffffff", light: "#b72025" } // match design
    });

    // Create container div
    const container = document.createElement("div");
    container.style.width = "105mm";
    container.style.height = "148mm";
    container.style.padding = "0";
    container.style.margin = "0";
    container.style.position = "relative";
    container.style.fontFamily = "'Poppins', sans-serif";

    // Build inner HTML
    container.innerHTML = `
        <div class="id-card" style="width:105mm; height:148mm; position:relative; overflow:hidden; background:#fff;">
            <!-- HEADER -->
                    <div class="header" style="
                        display:flex;
                        flex-direction:column;
                        width:100%;
                        margin:0;
                        padding:0;
                    ">

                        <!-- LOGO -->
                        <div class="logo" style="
                            height:26mm;
                            width:96%;
                            margin:2mm auto;
                            display:flex;
                            align-items:center;
                            justify-content:center;
                            border-bottom:1px solid #B62024;
                            padding-bottom:2mm;
                            box-sizing:border-box;
                        ">
                            <img 
                                src="${arctLogo}" 
                                style="
                                    height:20mm;
                                    width:auto;
                                    max-width:100%;
                                    display:block;
                                "
                            />
                        </div>

                                    <!-- SUBTITLE -->
                                    <div class="subtitle" style="
                                        font-size:12px;
                                        font-weight:600;
                                        color:#B62024;
                                        text-align:center;
                                        margin-bottom:4mm;
                                    ">
                                        Participated on
                                        <span style="
                                            font-weight:400;
                                            margin-left:3mm;
                                        ">
                                            ${formattedDate}
                                        </span>
                                    </div>

                                </div>


                                    <!-- BODY -->
                                <div class="container" style="
                            background-color:#b72025;
                            position:absolute;
                            top:36mm;
                            bottom:0;
                            left:0;
                            width:100%;
                            padding-top:7mm;
                            box-sizing:border-box;
                        ">

                <div class="qr" style="width:28mm; height:28mm; margin:auto;">
                    <img src="${qrDataUrl}" style="height:100%; width:100%; display:block"/>
                </div>

                <div class="reg_no" style="margin-top:2mm; text-align:center; color:#fff; font-size:18px;">${arct_roll_number}</div>

                <div class="details" style="margin-top:5mm; font-size:13px; text-align:center;">
                    <div class="name" style="font-weight:600; font-size:20px; color:#fff; border-bottom:1px solid #fff; margin:0 19mm; padding-bottom:2mm; letter-spacing:1px;">${name}</div>
                    <div class="fname" style="color:#fff; margin-top:2mm; letter-spacing:1px; font-size:17px;">S/o ${father_name || "-"}</div>
                </div>

                <!-- FOOTER -->
                <div class="footer" style="width:100%; position:absolute; bottom:3mm; left:0;">
                    <div class="footer-row" style="display:flex; justify-content:space-between; align-items:center; margin-bottom:2mm;">
                        <img src="${career}" class="footer-left" style="width:30%; height:auto; margin-left:3mm"/>
                        <img src="${ARCTBITE}" class="footer-right" style="width:25%; height:auto; margin-right:40px; align-self:end"/>
                    </div>
                    <div class="footer-row-center" style="display:flex; justify-content:center;">
                        <img src="${ARCTStrip}" class="footer-center" style="width:85%; height:auto"/>
                    </div>
                </div>
            </div>
        </div>
    `;

    document.body.appendChild(container);

    // Wait for all images to load
    const images = container.querySelectorAll("img");
    await Promise.all(Array.from(images).map(img => {
        if (img.complete) return Promise.resolve();
        return new Promise(resolve => { img.onload = img.onerror = resolve; });
    }));

    // Render to canvas
    const canvas = await html2canvas(container, { scale: 2, useCORS: true, allowTaint: false });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: [148, 105],
    });

    pdf.addImage(imgData, "PNG", 0, 0, 105, 148);

    document.body.removeChild(container);
    return pdf;
};


export const generateFeePlanPDF = (previewData) => {
    const {
        planMode,
        selectedCourse,
        selectedSemester,
        selectedStudent, // array of selected student IDs
        feeRows,
        selectedSections,
        selectedSession,
        students // full student objects
    } = previewData;
    console.log("previewData===", previewData)
    const doc = new jsPDF();
    const PAGE_HEIGHT = doc.internal.pageSize.height || 297;
    const MARGIN = 20;
    const LINE_HEIGHT = 8;

    let startY = MARGIN;

    // Helper to format amount as Rs with two decimals
    const formatAmount = (amount) => `Rs ${Number(amount || 0).toFixed(2)}`;

    // --- Filter selected students ---
    const selectedStudentObjects = students.filter(s =>
        selectedStudent.includes(s.id)
    );

    const totalStudents = selectedStudentObjects.length;


    // Compute total amount
    let totalAmount = 0;
    const feeRowTotal = feeRows.reduce(
        (sum, row) => sum + Number(row.amount || 0),
        0
    );


    if (planMode === "course") {
        // multiply sum of all fee heads by total number of selected students
        // const feeSumPerStudent = feeRows.reduce((sum, row) => sum + Number(row.amount || 0), 0);
        // totalAmount = feeSumPerStudent * totalStudents;
        if (selectedStudent.length === 0) {
            // ✅ Course mode + NO students
            totalAmount = feeRowTotal;
        } else {
            // ✅ Course mode + students exist (earlier behaviour)
            totalAmount = feeRowTotal * selectedStudent.length;
        }
    } else if (planMode === "individual") {
        selectedStudentObjects.forEach(stu => {
            feeRows.forEach(row => {
                totalAmount += Number(row.amount || 0);
            });
        });
    }


    // --- Helper to draw key/value with key bold ---
    const drawKeyValue = (key, value, x = 14, y = startY) => {
        doc.setFont(undefined, 'bold');
        doc.text(`${key}: `, x, y);
        const keyWidth = doc.getTextWidth(`${key}: `);
        doc.setFont(undefined, 'normal');
        doc.text(`${value}`, x + keyWidth, y);
    };

    // --- Table helpers ---
    const addCourseTableHeader = () => {
        doc.setFontSize(12);
        doc.text("Fee Head", 14, startY);
        doc.text("Amount", 100, startY);
        startY += LINE_HEIGHT;
    };

    const TABLE_X = 14;
    const TABLE_WIDTH = 180;
    const COL_WIDTHS = [60, 60, 50]; // Student Name, Fee Head, Amount

    const drawIndividualTableHeader = () => {
        doc.setFillColor(200, 200, 200); // light gray
        doc.rect(TABLE_X, startY, TABLE_WIDTH, LINE_HEIGHT, 'F'); // filled header
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);

        // Left-aligned columns
        doc.text("Student Name", TABLE_X + 2, startY + 6);
        doc.text("Fee Head", TABLE_X + COL_WIDTHS[0] + 2, startY + 6);

        // Right-aligned Amount header
        const amountHeader = "Amount";
        const amountX = TABLE_X + COL_WIDTHS[0] + COL_WIDTHS[1] + COL_WIDTHS[2] - 2;
        const textWidth = doc.getTextWidth(amountHeader);
        doc.text(amountHeader, amountX - textWidth, startY + 6);

        startY += LINE_HEIGHT;
    };

    // --- Add Title ---
    doc.setFontSize(18);
    doc.setFont(undefined, 'bold');
    doc.text("Impose Fee Plan Preview", 14, startY);
    startY += 10;

    // --- Top Info (keys bold, values normal) ---
    doc.setFontSize(12);
    drawKeyValue("Course", selectedCourse?.label || "N/A");
    startY += 8;
    drawKeyValue("Semester", selectedSemester?.label || "N/A");
    startY += 8;
    drawKeyValue("Sections", selectedSections?.map(s => s.label).join(", ") || "N/A");
    startY += 8;
    // drawKeyValue("Admission Academic Year", selectedSession?.label || "N/A");
    // startY += 8;
    drawKeyValue("Total Students", totalStudents);
    drawKeyValue("Total Amount", formatAmount(totalAmount), 100, startY);
    startY += 12;

    // --- Fee Table ---
    if (planMode === "course") {
        doc.setFontSize(14);
        doc.setFont(undefined, 'bold');
        doc.text("Fee Details", 14, startY);
        startY += 12; // space before table

        const TABLE_X = 14;
        const TABLE_WIDTH = 180;
        const COL_WIDTHS = [120, 60]; // Fee Head, Amount

        // Draw table header
        doc.setFillColor(200, 200, 200);
        doc.rect(TABLE_X, startY, TABLE_WIDTH, LINE_HEIGHT, 'F');
        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.text("Fee Head", TABLE_X + 2, startY + 6);
        const amountHeader = "Amount";
        const amountX = TABLE_X + COL_WIDTHS[0] + COL_WIDTHS[1] - 2;
        const textWidthHeader = doc.getTextWidth(amountHeader);
        doc.text(amountHeader, amountX - textWidthHeader, startY + 6);
        startY += LINE_HEIGHT;

        doc.setFont(undefined, 'normal');

        // Draw rows
        feeRows.forEach((row) => {
            if (startY + LINE_HEIGHT > PAGE_HEIGHT - MARGIN) {
                doc.addPage();
                startY = MARGIN;
                // redraw header
                doc.setFillColor(200, 200, 200);
                doc.rect(TABLE_X, startY, TABLE_WIDTH, LINE_HEIGHT, 'F');
                doc.setFont(undefined, 'bold');
                doc.text("Fee Head", TABLE_X + 2, startY + 6);
                const textWidthHeader2 = doc.getTextWidth(amountHeader);
                doc.text(amountHeader, amountX - textWidthHeader2, startY + 6);
                startY += LINE_HEIGHT;
                doc.setFont(undefined, 'normal');
            }

            // Draw row rectangle
            doc.rect(TABLE_X, startY, TABLE_WIDTH, LINE_HEIGHT);

            // Add text
            doc.text(row.fee_type_head || "", TABLE_X + 2, startY + 6);

            // Right-align Amount
            const amountText = formatAmount(row.amount);
            const textWidthRow = doc.getTextWidth(amountText);
            doc.text(amountText, amountX - textWidthRow, startY + 6);

            startY += LINE_HEIGHT;
        });

        startY += 12; // space after table
    } else if (planMode === "individual") {
        doc.setFontSize(14);
        doc.setFont(undefined, 'bold');
        doc.text("Students Fee Details", 14, startY);
        startY += 12;

        drawIndividualTableHeader();

        doc.setFont(undefined, 'normal');

        selectedStudentObjects.forEach((stu) => {
            feeRows.forEach((row) => {
                if (startY + LINE_HEIGHT > PAGE_HEIGHT - MARGIN) {
                    doc.addPage();
                    startY = MARGIN;
                    drawIndividualTableHeader();
                    doc.setFont(undefined, 'normal');
                }

                // Draw row rectangle
                doc.rect(TABLE_X, startY, TABLE_WIDTH, LINE_HEIGHT);

                // Add text
                doc.text(stu.name || "", TABLE_X + 2, startY + 6);
                doc.text(row.fee_type_head || "", TABLE_X + COL_WIDTHS[0] + 2, startY + 6);

                // Right-align Amount
                const amountText = formatAmount(row.amount);
                const amountX = TABLE_X + COL_WIDTHS[0] + COL_WIDTHS[1] + COL_WIDTHS[2] - 2;
                const textWidth = doc.getTextWidth(amountText);
                doc.text(amountText, amountX - textWidth, startY + 6);

                startY += LINE_HEIGHT;
            });
        });

        startY += 12;
    }

    // Generate PDF
    const pdfBlob = doc.output("blob");
    // const url = URL.createObjectURL(pdfBlob);
    // const link = document.createElement("a");
    // link.href = url;
    // link.download = `FeePlan_${planMode}.pdf`;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
    // URL.revokeObjectURL(url);

    return pdfBlob;
};



export const formatDateReadable = (date) => {
    const d = new Date(date);
    const day = d.getDate();
    const monthShort = d.toLocaleString("default", { month: "short" });
    const year = d.getFullYear();

    // Add suffix (1st, 2nd, 3rd, etc.)
    const suffix =
        day % 10 === 1 && day !== 11
            ? "st"
            : day % 10 === 2 && day !== 12
                ? "nd"
                : day % 10 === 3 && day !== 13
                    ? "rd"
                    : "th";

    return `${day}${suffix} ${monthShort} ${year}.`;
};






const drawFooter = (doc, pageWidth, pageHeight, marginX, base64DirectorSign, copyToList) => {

    const signatureWidth = 45;
    const signatureHeight = 28;
    const marginRight = 25;

    const signatureX = pageWidth - marginRight - signatureWidth;
    const signatureY = pageHeight - 60;

    doc.addImage(base64DirectorSign, "PNG", signatureX, signatureY, signatureWidth, signatureHeight);

    doc.setFont("times", "bold").setFontSize(12);
    doc.text("Director", signatureX + signatureWidth / 2, signatureY + signatureHeight + 4, {
        align: "center",
    });

    if (copyToList.length > 0) {
        doc.setFont("times", "bold").setFontSize(12);
        doc.text("Copy to:", marginX, signatureY);

        doc.setFont("times", "normal").setFontSize(11);
        let listY = signatureY + 5;

        copyToList.forEach((c, i) => {
            const reasonText = c.reason ? ` (${c.reason})` : "";
            doc.text(`${i + 1}. ${c.designation}${reasonText}`, marginX + 10, listY);
            listY += 5;
        });
    }
};


const drawFooterForResend = (
    doc,
    pageWidth,
    pageHeight,
    marginX,
    base64DirectorSign,
    copyToList
) => {

    const signatureWidth = 45;
    const signatureHeight = 28;
    const marginRight = 25;

    const signatureX = pageWidth - marginRight - signatureWidth;
    const signatureY = pageHeight - 60;

    // Director signature
    doc.addImage(
        base64DirectorSign,
        "PNG",
        signatureX,
        signatureY,
        signatureWidth,
        signatureHeight
    );

    doc.setFont("times", "bold").setFontSize(12);
    doc.text("Director", signatureX + signatureWidth / 2, signatureY + signatureHeight + 4, {
        align: "center",
    });

    // Copy To List (show only if length > 0)
    if (copyToList && copyToList.length > 0) {
        doc.setFont("times", "bold").setFontSize(12);
        doc.text("Copy to:", marginX, signatureY);

        doc.setFont("times", "normal").setFontSize(11);

        let listY = signatureY + 5;

        copyToList.forEach((c, i) => {
            const reasonText = c.reason ? ` (${c.reason})` : "";
            const designation = c.designation_id ? c.designation_id : "";
            doc.text(`${i + 1}. ${designation}${reasonText}`, marginX + 10, listY);
            listY += 5;
        });
    }
};


export const generateScheduledFeePDF = async (previewData, uniqueFileName) => {
    const {
        selectedCourse,
        selectedSemester,
        dueDate,
        calcImposePenalty,
        calcPenaltyAmount,
        calcPenaltyMaxAmount,
    } = previewData;

    // console.log("previewData===,",previewData)

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const marginX = 25;
    const maxWidth = pageWidth - 2 * marginX;
    let y = 20;

    // 🔹 Helper to convert image URL to Base64
    const toBase64 = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    };

    // 🔹 Logo
    const base64Logo = await toBase64(image);
    doc.addImage(base64Logo, "PNG", pageWidth / 2 - 15, y, 30, 30);
    y += 38;

    doc.setFont("helvetica", "bold").setFontSize(16);
    doc.text("Banaras Institute of Teacher's Education", pageWidth / 2, y, { align: "center" });
    y += 7;
    doc.setFont("helvetica", "normal").setFontSize(12);
    doc.text("(Affiliated to Mahatma Gandhi Kashi Vidyapeeth, Varanasi)", pageWidth / 2, y, {
        align: "center",
    });
    y += 7;
    doc.setFont("helvetica", "bold").setFontSize(12);
    doc.text("Babatpur, Varanasi", pageWidth / 2, y, { align: "center" });

    // 🔹 Separator Line
    y += 10;
    doc.line(20, y, pageWidth - 20, y);

    const generatedDate = new Date().toLocaleString();

    // 🔹 Ref.No. & Date Row
    y += 8;
    doc.setFont("times", "normal").setFontSize(10);
    doc.text("Ref.No.:", marginX, y);
    doc.setFont("times", "bold");
    doc.text(`${uniqueFileName}`, marginX + doc.getTextWidth("Ref.No.: ") + 2, y);

    const dateLabel = "Date:";
    doc.setFont("times", "normal");
    doc.text(dateLabel, pageWidth - marginX - doc.getTextWidth(`${dateLabel} ${generatedDate}`), y);
    doc.setFont("times", "bold");
    doc.text(generatedDate, pageWidth - marginX, y, { align: "right" });

    // 🔹 Notice Title
    y += 12;
    doc.setFont("times", "bold").setFontSize(14);
    const noticeText = "Important Notice";
    const textWidth = doc.getTextWidth(noticeText);
    const textX = pageWidth / 2 - textWidth / 2;
    doc.text(noticeText, pageWidth / 2, y, { align: "center" });
    doc.line(textX, y + 1, textX + textWidth, y + 1);

    y += 10;
    const courseSemesterText = formatCourseListWithRoman(
        selectedSemester?.length > 0
            ? selectedSemester.map((s) => s.label)
            : selectedCourse?.map((c) => c.label) || []
    );
    const formattedDate = formatDateReadable(dueDate);
    const lineHeight = 7;
    let x = marginX;


    // 🔹 Footer Section (Right-Aligned Signature + Left Copy To)
    const base64DirectorSign = await toBase64(directorSignImage);
    const copyToList =
        (previewData.copyToDisplayData || []).filter(
            (c) => c.designation && c.designation.trim() !== ""
        ) || [];


    // -----------------------------------------------------
    // FOOTER PAGE-BREAK CHECKER (must be defined before use)
    // -----------------------------------------------------
    const checkPageBreak = () => {
        const currentPageHeight = doc.internal.pageSize.getHeight();
        if (y > currentPageHeight - 80) {
            // drawFooter(doc, pageWidth, currentPageHeight, marginX, base64DirectorSign, copyToList);
            doc.addPage();
            y = 30;
        }
    };

    // 🔹 Show general notice only if NOT individual
    if (previewData?.payload?.plan_mode !== "individual") {
        const parts = [
            {
                text: "This is to inform all students of ",
                bold: false,
            },
            { text: courseSemesterText, bold: true },
            { text: " that they must deposit their pending fees by", bold: false },
            { text: formattedDate, bold: true },
        ];

        doc.setFont("times", "normal").setFontSize(13);
        for (const part of parts) {
            doc.setFont("times", part.bold ? "bold" : "normal");
            const words = part.text.split(" ");
            for (let i = 0; i < words.length; i++) {
                const word = words[i] + (i < words.length - 1 ? " " : "");
                const w = doc.getTextWidth(word);
                if (x + w > marginX + maxWidth) {
                    y += lineHeight;
                    x = marginX;
                }
                doc.text(word, x, y);
                x += w;
            }
        }
    }


    if (previewData?.payload?.plan_mode === "individual") {
        const studentIds = previewData?.payload?.student_ids
            ?.split(",")
            ?.map((id) => Number(id.trim()));
        const matchedStudents = previewData?.filteredStudents?.filter((s) =>
            studentIds?.includes(s.id)
        );

        if (matchedStudents?.length) {
            y += 10;
            doc.setFont("times", "normal").setFontSize(13);

            const courseText = formatCourseListWithRoman(
                selectedSemester?.length > 0
                    ? selectedSemester.map((s) => s.label)
                    : selectedCourse?.map((c) => c.label) || []
            );

            const formattedDate = formatDateReadable(dueDate);

            // ✅ Split into styled parts (manual bold for course name)
            const headingParts = [
                { text: "The following students of ", bold: false },
                { text: `(${courseText})`, bold: true },
                { text: " are hereby informed to deposit their pending fees by ", bold: false },
                { text: `${formattedDate}:`, bold: true },
            ];

            const lineHeight = 7;
            let x = marginX;

            for (const part of headingParts) {
                doc.setFont("times", part.bold ? "bold" : "normal");
                const words = part.text.split(" ");
                for (let i = 0; i < words.length; i++) {
                    const word = words[i] + (i < words.length - 1 ? " " : "");
                    const w = doc.getTextWidth(word);
                    if (x + w > marginX + maxWidth) {
                        y += lineHeight;
                        x = marginX;
                    }
                    doc.text(word, x, y);
                    x += w;
                }
            }

            // move below heading
            y += lineHeight + 4;

            // list names (with dot)
            doc.setFont("times", "normal").setFontSize(12);
            matchedStudents.forEach((s, i) => {
                checkPageBreak();
                doc.text(`${i + 1}. ${s.name} (${s.rollNumber})`, marginX + 5, y);
                y += 6;
            });
        }
    }


    // 🔹 Penalty Section
    y += 14;
    if (calcImposePenalty) {
        doc.setFont("times", "bold").setFontSize(13);
        doc.text("Important:", marginX, y);
        y += 8;

        const penaltyParts = [
            { text: "• Delay in fee will attract a penalty of ", bold: false },
            { text: `Rs ${calcPenaltyAmount}`, bold: true },
            { text: " per day, subject to a maximum of ", bold: false },
            { text: `Rs ${calcPenaltyMaxAmount?.toFixed(2)}.`, bold: true },
        ];

        x = marginX + 5;
        doc.setFontSize(12);
        for (const part of penaltyParts) {
            doc.setFont("times", part.bold ? "bold" : "normal");
            const words = part.text.split(" ");
            for (let i = 0; i < words.length; i++) {
                const word = words[i] + (i < words.length - 1 ? " " : "");
                const w = doc.getTextWidth(word);
                if (x + w > marginX + maxWidth) {
                    y += lineHeight;
                    x = marginX + 5;
                }
                doc.text(word, x, y);
                x += w;
            }
        }

        y += 8;
        const secondLine =
            "• Students are advised to pay the fee within the stipulated time to avoid penalties.";
        doc.setFont("times", "normal").setFontSize(12);
        const wrapped = doc.splitTextToSize(secondLine, maxWidth);
        doc.text(wrapped, marginX + 5, y);
        y += doc.getTextDimensions(wrapped).h + 4;
    }


    const pageHeight = doc.internal.pageSize.getHeight();
    const signatureWidth = 45;
    const signatureHeight = 28;
    const marginRight = 25;

    drawFooter(doc, pageWidth, doc.internal.pageSize.getHeight(), marginX, base64DirectorSign, copyToList);

    // 🔹 Generate PDF File
    const pdfBlob = doc.output("blob");
    // const url = URL.createObjectURL(pdfBlob);
    // const link = document.createElement("a");
    // link.href = url;
    // link.download = `ScheduledFee_${new Date().toISOString().split("T")[0]}.pdf`;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
    // URL.revokeObjectURL(url);
    return pdfBlob;
};

export const generateResendScheduledFeePDF = async (previewData) => {
    console.log("previewData===", previewData)
    const { id, full_course_name, due_date, copied_to = [], course_mode, students_list = [] } = previewData;

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const marginX = 25;
    let y = 20;

    // 🔹 Convert image URL to Base64
    const toBase64 = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    };

    // ---- Header Logo ----
    const base64Logo = await toBase64(image);
    doc.addImage(base64Logo, "PNG", pageWidth / 2 - 15, y, 30, 30);
    y += 36;

    // ---- Institute Header ----
    doc.setFont("helvetica", "bold").setFontSize(16);
    doc.text("Banaras Institute of Teacher's Education", pageWidth / 2, y, { align: "center" });
    y += 6;
    doc.setFont("helvetica", "normal").setFontSize(12);
    doc.text("(Affiliated to Mahatma Gandhi Kashi Vidyapeeth, Varanasi)", pageWidth / 2, y, { align: "center" });
    y += 6;
    doc.setFont("helvetica", "bold").setFontSize(12);
    doc.text("Babatpur, Varanasi", pageWidth / 2, y, { align: "center" });

    // ---- Separator Line ----
    y += 6;
    doc.line(20, y, pageWidth - 20, y);

    // ---- Ref.No. & Date ----
    y += 8;
    const generatedDate = new Date().toLocaleString();
    doc.setFont("times", "normal").setFontSize(10);
    doc.text("Ref.No.:", marginX, y);
    doc.setFont("times", "bold");
    doc.text(id || "-", marginX + 18, y);

    doc.setFont("times", "normal");
    const dateLabel = "Date:";
    const dateValue = generatedDate;
    const dateLabelWidth = doc.getTextWidth(dateLabel);
    const dateValueWidth = doc.getTextWidth(dateValue);
    const totalWidth = dateLabelWidth + dateValueWidth + 4;
    doc.text(dateLabel, pageWidth - marginX - totalWidth, y);
    doc.setFont("times", "bold");
    doc.text(dateValue, pageWidth - marginX, y, { align: "right" });

    // ---- Important Notice ----
    y += 12;
    doc.setFont("times", "bold").setFontSize(14);
    const titleText = "Important Notice";
    const titleWidth = doc.getTextWidth(titleText);
    doc.text(titleText, pageWidth / 2, y, { align: "center" });
    doc.line(pageWidth / 2 - titleWidth / 2 - 3, y + 1, pageWidth / 2 + titleWidth / 2 + 3, y + 1);

    // ---- Notice Body ----
    y += 10;
    doc.setFont("times", "normal").setFontSize(12);

    const formattedDate = formatDate(new Date(due_date));
    const courseList = full_course_name.split("\n").filter(Boolean);
    const formattedCoursesArr = formatCourseListWithRoman(courseList);
    const courseText = Array.isArray(formattedCoursesArr)
        ? formattedCoursesArr.join(", ")
        : formattedCoursesArr;


    // -------------------------------------------------
    // FOOTER PAGE-BREAK CHECKER (same as Scheduled PDF)
    // -------------------------------------------------
    const checkPageBreak = () => {
        const currentPageHeight = doc.internal.pageSize.getHeight();
        if (y > currentPageHeight - 80) {
            doc.addPage();
            y = 30;
        }
    };


    if (course_mode === "Individual wise" && Array.isArray(students_list) && students_list.length > 0) {
        // ✅ For "Individual wise" mode
        doc.setFont("times", "normal").setFontSize(12);

        // Paragraph intro
        doc.text(
            `The following students of ${courseText} are hereby informed to deposit their pending fees by ${formattedDate}:`,
            marginX,
            y,
            { maxWidth: pageWidth - 2 * marginX }
        );

        y += 20;

        // Student listing
        doc.setFont("times", "normal").setFontSize(12);
        students_list.forEach((s, i) => {
            checkPageBreak();
            const studentLine = `${i + 1}. ${s.student_name} (${s.student_registration}) (${s.course_name})`;
            doc.text(studentLine, marginX + 5, y);
            y += 6;

            // Add page if space ends
            if (y > 270) {
                doc.addPage();
                y = 20;
            }
        });
    } else {
        // ✅ For "Course wise" mode (old logic)
        const firstPart = " This is to inform all students of  ";
        const thirdPart = ` that they must deposit their pending fees by ${formattedDate}.`;

        // --- Bolded courses and date ---
        let textWithMarkers = `${firstPart}${courseText}${thirdPart}`;
        textWithMarkers = textWithMarkers.replace(courseText, "<<COURSE>>");
        textWithMarkers = textWithMarkers.replace(formattedDate, "<<DATE>>");

        const words = textWithMarkers.split(/\s+/);
        let currentLine = "";
        const lineHeight = 6;
        const maxWidth = pageWidth - 2 * marginX;

        words.forEach((word, idx) => {
            const testLine = currentLine + (currentLine ? " " : "") + word;
            const testWidth = getTextWidthWithMarkers(doc, testLine, courseText, formattedDate);

            if (testWidth > maxWidth) {
                drawLineWithBold(doc, currentLine, y, marginX, courseText, formattedDate);
                y += lineHeight;
                currentLine = word;
            } else {
                currentLine = testLine;
            }

            if (idx === words.length - 1) {
                drawLineWithBold(doc, currentLine, y, marginX, courseText, formattedDate);
                y += lineHeight;
            }
        });
    }

    // --- Helper: Draw line with bold markers ---
    function drawLineWithBold(doc, line, y, marginX, course, formattedDate) {
        let currentX = marginX;
        const parts = line.split(/(<<COURSE>>|<<DATE>>)/g);
        parts.forEach((part) => {
            if (part === "<<COURSE>>") {
                doc.setFont("times", "bold");
                doc.text(course, currentX, y);
                currentX += doc.getTextWidth(course);
            } else if (part === "<<DATE>>") {
                doc.setFont("times", "bold");
                doc.text(formattedDate, currentX, y);
                currentX += doc.getTextWidth(formattedDate);
            } else {
                doc.setFont("times", "normal");
                doc.text(part, currentX, y);
                currentX += doc.getTextWidth(part);
            }
        });
    }

    function getTextWidthWithMarkers(doc, line, course, formattedDate) {
        const parts = line.split(/(<<COURSE>>|<<DATE>>)/g);
        let totalWidth = 0;
        parts.forEach((part) => {
            if (part === "<<COURSE>>") {
                doc.setFont("times", "bold");
                totalWidth += doc.getTextWidth(course);
            } else if (part === "<<DATE>>") {
                doc.setFont("times", "bold");
                totalWidth += doc.getTextWidth(formattedDate);
            } else {
                doc.setFont("times", "normal");
                totalWidth += doc.getTextWidth(part);
            }
        });
        return totalWidth;
    }

    y += 10;

    // 🔹 Footer Section (Right-Aligned Signature + Left Copy To)
    const base64DirectorSign = await toBase64(directorSignImage);

    // ---- Director Signature ----
    drawFooterForResend(doc, pageWidth, doc.internal.pageSize.getHeight(), marginX, base64DirectorSign, copied_to);
    // ---- Download ----
    const pdfBlob = doc.output("blob");
    // const url = URL.createObjectURL(pdfBlob);
    // const link = document.createElement("a");
    // link.href = url;
    // link.download = `ResendNotice_${new Date().toISOString().split("T")[0]}.pdf`;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
    // URL.revokeObjectURL(url);

    return pdfBlob;
};


export const generateDiscountPDF = (previewData, approvedByName, selectedSessionName) => {
    const {
        students,
        feeHeadNames,
        discountAmount,
        mode,
        selectedCourse,
        selectedSemester,
    } = previewData;


    const doc = new jsPDF();
    const PAGE_HEIGHT = doc.internal.pageSize.height || 297;
    const MARGIN = 20;
    const LINE_HEIGHT = 8;
    let startY = MARGIN;

    const formatAmount = (amt) => `Rs${Number(amt || 0).toFixed(2)}`;

    // ---- Header ----
    doc.setFontSize(18);
    doc.setFont(undefined, "bold");
    doc.text("Discount Preview", 14, startY);
    startY += 12;

    // ---- Flex-style Key/Value Renderer ----
    doc.setFontSize(12);
    const drawFlexDetails = (detailsLeft, detailsRight) => {
        const startXLeft = 14;
        const startXRight = 110; // second column X position
        const lineGap = 7;
        const maxLines = Math.max(detailsLeft.length, detailsRight.length);

        for (let i = 0; i < maxLines; i++) {
            const left = detailsLeft[i];
            const right = detailsRight[i];

            if (left) {
                doc.setFont(undefined, "bold");
                doc.text(`${left.k}: `, startXLeft, startY);
                const wL = doc.getTextWidth(`${left.k}: `);
                doc.setFont(undefined, "normal");
                doc.text(left.v || "N/A", startXLeft + wL, startY);
            }

            if (right) {
                doc.setFont(undefined, "bold");
                doc.text(`${right.k}: `, startXRight, startY);
                const wR = doc.getTextWidth(`${right.k}: `);
                doc.setFont(undefined, "normal");
                doc.text(right.v || "N/A", startXRight + wR, startY);
            }

            startY += lineGap;
        }

        startY += 6; // small gap after section
    };

    // ---- Calculations ----
    const totalStudents = (previewData?.payload?.student_ids || "")
        .split(",")
        .filter(Boolean).length;
    const perStudentDiscount = Number(discountAmount || 0);
    const totalDiscount = totalStudents * perStudentDiscount;

    // ---- Build detail arrays ----
    const leftDetails = [
        // { k: "Admission Academic Year", v: selectedSessionName },
        { k: "Course", v: selectedCourse?.label },
        { k: "Total Students", v: String(totalStudents) },
        { k: "Approved By", v: approvedByName || "N/A" },
    ];

    const rightDetails = [
        { k: "Semester", v: selectedSemester?.label },
        { k: "Plan Mode", v: mode === "course" ? "Course-wise" : "Individual-wise" },
        {
            k: "Discount Amount",
            v: `${formatAmount(perStudentDiscount)}  (Total: ${formatAmount(totalDiscount)})`,
        },
    ];

    // ---- Render header details in flex layout ----
    drawFlexDetails(leftDetails, rightDetails);

    // ---- Fee Heads ----
    doc.setFont(undefined, "bold");
    doc.text("Applicable Fee Heads:", 14, startY);
    startY += 6;
    doc.setFont(undefined, "normal");
    feeHeadNames.forEach((name) => {
        doc.text(`• ${name}`, 18, startY);
        startY += 6;
    });
    startY += 10;

    // ---- Table Header ----
    doc.setFont(undefined, "bold");
    doc.text("Students Receiving Discount:", 14, startY);
    startY += 6;

    const TABLE_X = 14;
    const TABLE_WIDTH = 180;
    const COL_WIDTHS = [60, 80, 40];

    const drawHeader = () => {
        doc.setFillColor(200, 200, 200);
        doc.rect(TABLE_X, startY, TABLE_WIDTH, LINE_HEIGHT, "F");
        doc.text("Student Name", TABLE_X + 2, startY + 6);
        doc.text("Student ID", TABLE_X + COL_WIDTHS[0] + 2, startY + 6);
        const amtHeader = "Discount";
        const amtX =
            TABLE_X + COL_WIDTHS[0] + COL_WIDTHS[1] + COL_WIDTHS[2] - 2;
        const tWidth = doc.getTextWidth(amtHeader);
        doc.text(amtHeader, amtX - tWidth, startY + 6);
        startY += LINE_HEIGHT;
    };

    drawHeader();
    doc.setFont(undefined, "normal");

    students.forEach((stu) => {
        if (startY + LINE_HEIGHT > PAGE_HEIGHT - MARGIN) {
            doc.addPage();
            startY = MARGIN;
            drawHeader();
        }
        doc.rect(TABLE_X, startY, TABLE_WIDTH, LINE_HEIGHT);
        doc.text(stu.name || "", TABLE_X + 2, startY + 6);
        doc.text(String(stu.rollNumber || ""), TABLE_X + COL_WIDTHS[0] + 2, startY + 6);
        const amtText = formatAmount(discountAmount);
        const amtX =
            TABLE_X + COL_WIDTHS[0] + COL_WIDTHS[1] + COL_WIDTHS[2] - 2;
        const tw = doc.getTextWidth(amtText);
        doc.text(amtText, amtX - tw, startY + 6);
        startY += LINE_HEIGHT;
    });

    startY += 12;
    doc.text(`Generated on: ${formatDateDDMMYYYY(new Date())}`, 14, startY);

    // ---- Generate Blob ----
    const pdfBlob = doc.output("blob");

    // Trigger download
    const url = URL.createObjectURL(pdfBlob);
    // const link = document.createElement("a");
    // link.href = url;
    // link.download = `DiscountSummary_${new Date().toISOString().split("T")[0]}.pdf`;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
    // URL.revokeObjectURL(url);

    return pdfBlob;
};




export const generateDiscountPDFDashboard = (previewData, selectedSessionName) => {
    const {
        students = [],
        total_discount_amount,
        full_course_name,
        academic_year,
        fee_head_names = [],
        mode = "individual"
    } = previewData;



    const doc = new jsPDF();
    const PAGE_HEIGHT = doc.internal.pageSize.height || 297;
    const MARGIN = 20;
    const LINE_HEIGHT = 8;
    let startY = MARGIN;

    const formatAmount = (amt) => `Rs ${Number(amt || 0).toFixed(2)}`;

    // ---- Header ----
    doc.setFontSize(18);
    doc.setFont(undefined, "bold");
    doc.text("Discount Preview", 14, startY);
    startY += 12;

    // ---- Top Details in Two Columns ----
    doc.setFontSize(12);
    const leftX = 14;
    const rightX = 110; // right column start
    let leftY = startY;
    let rightY = startY;

    const drawKV = (x, y, key, value) => {
        doc.setFont(undefined, "bold");
        doc.text(`${key}: `, x, y);
        const w = doc.getTextWidth(`${key}: `);
        doc.setFont(undefined, "normal");
        doc.text(value || "N/A", x + w, y);
    };

    // Left column
    // drawKV(leftX, leftY, "Admission Academic Year", selectedSessionName || academic_year);
    // leftY += 7;
    drawKV(leftX, leftY, "Course", full_course_name);
    leftY += 7;
    drawKV(leftX, leftY, "Plan Mode", mode === "course" ? "Course-wise" : "Individual-wise");
    leftY += 7;

    // Total students
    const totalStudents = students?.length || 0;
    drawKV(leftX, leftY, "Total Students", String(totalStudents));
    leftY += 7;

    // Right column
    drawKV(rightX, rightY, "Total Discount Amount", formatAmount(total_discount_amount));
    rightY += 7;
    drawKV(rightX, rightY, "Approved By", students?.[0]?.approved_by_employee || "N/A");
    rightY += 7;
    drawKV(rightX, rightY, "Generated On", formatDateDDMMYYYY(new Date()));

    // Move startY below the columns
    startY = Math.max(leftY, rightY) + 10;

    // ---- Fee Heads ----
    doc.setFont(undefined, "bold");
    doc.text("Applicable Fee Heads:", 14, startY);
    startY += 6;
    doc.setFont(undefined, "normal");
    doc.text(`• ${fee_head_names?.join(", ") || "N/A"}`, 18, startY);
    startY += 10;

    // ---- Table Header ----
    doc.setFont(undefined, "bold");
    doc.text("Students Receiving Discount:", 14, startY);
    startY += 6;

    const TABLE_X = 14;
    const TABLE_WIDTH = 180;
    const COL_WIDTHS = [60, 80, 40];

    const drawHeader = () => {
        doc.setFillColor(200, 200, 200);
        doc.rect(TABLE_X, startY, TABLE_WIDTH, LINE_HEIGHT, "F");
        doc.text("Student Name", TABLE_X + 2, startY + 6);
        doc.text("Student Reg No", TABLE_X + COL_WIDTHS[0] + 2, startY + 6);
        const amtHeader = "Discount";
        const amtX = TABLE_X + COL_WIDTHS[0] + COL_WIDTHS[1] + COL_WIDTHS[2] - 2;
        const tWidth = doc.getTextWidth(amtHeader);
        doc.text(amtHeader, amtX - tWidth, startY + 6);
        startY += LINE_HEIGHT;
    };

    drawHeader();
    doc.setFont(undefined, "normal");

    students.forEach((stu) => {
        if (startY + LINE_HEIGHT > PAGE_HEIGHT - MARGIN) {
            doc.addPage();
            startY = MARGIN;
            drawHeader();
        }

        doc.rect(TABLE_X, startY, TABLE_WIDTH, LINE_HEIGHT);
        doc.text(stu.student_name || "", TABLE_X + 2, startY + 6);
        doc.text(stu.registration_number || "", TABLE_X + COL_WIDTHS[0] + 2, startY + 6);

        const amtText = formatAmount(stu.discount);
        const amtX = TABLE_X + COL_WIDTHS[0] + COL_WIDTHS[1] + COL_WIDTHS[2] - 2;
        const tw = doc.getTextWidth(amtText);
        doc.text(amtText, amtX - tw, startY + 6);

        startY += LINE_HEIGHT;
    });

    startY += 12;

    // ---- Generate Blob and trigger download ----
    const pdfBlob = doc.output("blob");
    // const url = URL.createObjectURL(pdfBlob);
    // const link = document.createElement("a");
    // link.href = url;
    // link.download = `DiscountSummary_${new Date().toISOString().split("T")[0]}.pdf`;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
    // URL.revokeObjectURL(url);

    return pdfBlob;
};








